module.exports = __webpack_public_path__ + "dm.1e04d3b8e6e148ff23d4.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/dm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/dm.svg
// module chunks = styles